/**
 * TASKS-LIST.WIDGET
 * Get list of actions to do for a user
 */

import { store } from "@/index"
import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import { ActionPlanState, ActionPlanTask, ActionPlanTaskStatus, TASK_STATUS_LIST } from "@/redux/action-plan.types"
import TasksCardWidget from "./tasks-card.widget"
import { Droppable, DragDropContext } from "react-beautiful-dnd"
import TasksDescriptionWidget from "./tasks-description.widget"
import { actionPlanEditTask } from "@/redux/action-plan.actions"
import { Session } from "@/redux/_session.types"

interface StateProps extends WithTranslation {
  _session: Session
  actionPlan: ActionPlanState
}

interface OwnProps {
  isSmall?: boolean
}

type Props = StateProps & OwnProps

function TasksListWidget(props: Props) {
  const { t } = props

  //Change status of a tasks by dragging drop
  function changeStatus(e) {
    let task = props.actionPlan.active.tasks.find((x) => x.id === e.draggableId)
    if (e.destination && task) {
      task = new ActionPlanTask(task)
      task.status = e.destination.droppableId
      store.dispatch(actionPlanEditTask(task))
    }
  }

  return (
    <div className="flex1">
      {!props.isSmall && <TasksDescriptionWidget />}

      <DragDropContext onDragEnd={changeStatus}>
        <div className={props.isSmall ? "tasks-column-container tasks-column-container-small" : "flex tasks-column-container"}>
          {TASK_STATUS_LIST.map((status: ActionPlanTaskStatus) => (
            <div key={status} className={props.isSmall ? "tasks-column medgrey-b" : "flex1 tasks-column medgrey-b"}>
              <Droppable droppableId={status} type="TASKS_driSTATUS">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={snapshot.isDraggingOver ? "tasks-column-over" : ""}
                    style={{ height: "100%" }}>
                    <div className="flex tasks-column-title medgrey white-t">{t("tasks_status_" + status)}</div>

                    <div className="tasks-column-card-container">
                      {props.actionPlan.active.tasks
                        .filter((x) => x.status === status)
                        .map((task: ActionPlanTask, i: number) => (
                          <TasksCardWidget draggableIndex={i} key={task.id} isDraggable currentTask={task} />
                        ))}

                      {status === "todo" && (
                        <div
                          style={{
                            padding: 16,
                            textAlign: "center",
                            marginBottom: 16
                          }}></div>
                      )}

                      {provided.placeholder}
                    </div>
                  </div>
                )}
              </Droppable>
            </div>
          ))}
        </div>
      </DragDropContext>
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  actionPlan: state.actionPlan
})

export default connect(mapStateToProps)(withTranslation()(TasksListWidget))
